export const valueToString = (value: string | string[]) => (Array.isArray(value) ? value.join(', ') : value) || '';
